export type PluralForms = readonly [one: string, few: string, many: string];

/** Russian plural form: 1 товар, 2 товара, 5 товаров. */
export function pluralize(count: number, forms: PluralForms): string {
  const n = Math.abs(Math.trunc(count));
  const lastTwo = n % 100;
  const last = n % 10;
  if (lastTwo >= 11 && lastTwo <= 14) return forms[2];
  if (last === 1) return forms[0];
  if (last >= 2 && last <= 4) return forms[1];
  return forms[2];
}

export function formatCount(count: number, forms: PluralForms): string {
  return `${count} ${pluralize(count, forms)}`;
}

export const GOODS_FORMS: PluralForms = ['товар', 'товара', 'товаров'];
export const THINGS_FORMS: PluralForms = ['вещь', 'вещи', 'вещей'];
export const BONUS_FORMS: PluralForms = ['бонус', 'бонуса', 'бонусов'];
export const DAYS_FORMS: PluralForms = ['день', 'дня', 'дней'];
